var React = require('react');

function PodCast (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_3911_65558)","key":0},[React.createElement("rect",{"x":"5.5","y":"0.5","width":"5","height":"10","rx":"2.5","stroke":"currentColor","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M3 8V8C3 10.7614 5.23858 13 8 13V13C10.7614 13 13 10.7614 13 8V8","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"5.5","y1":"15.5","x2":"10.5","y2":"15.5","stroke":"currentColor","strokeLinecap":"square","key":2}),React.createElement("path",{"d":"M8 13L8 15","stroke":"currentColor","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_3911_65558"},React.createElement("rect",{"width":"16","height":"16","fill":"currentColor"})))]);
}

PodCast.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = PodCast;

PodCast.default = PodCast;
